//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  mounted(){
    const that = this;
    let hasClick = false;
    window.addEventListener('message', function(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          console.log('location', loc);

          if(loc && !hasClick){
            that.$store.commit('updateAddress',loc);
            that.$router.push({
              name: 'home'
            })
            hasClick = true
          }
        }
    }, false);
  }
}



// WEBPACK FOOTER //
// ./src/components/Map.vue